import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldOff, LogIn, UserCheck } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const LinkRevoked = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user, loading } = useAuth();
  const accountLabel = user?.full_name || user?.username || user?.email;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 shadow-2xl max-w-md w-full mx-4" data-testid="link-revoked-card">
        <div className="text-center">
          <ShieldOff className="w-16 h-16 text-amber-400 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-white mb-2">Access link revoked</h2>
          <p className="text-slate-300 mb-2">
            Your quick access link was revoked by your administrator, so this session has ended.
          </p>
          {!loading && isAuthenticated ? (
            <>
              <p className="text-slate-400 text-sm mb-6" data-testid="link-revoked-existing-session-note">
                This browser is already signed in as <span className="text-slate-200 font-medium">{accountLabel}</span>. You can continue with that account, or sign in as someone else.
              </p>
              <div className="flex flex-col gap-3">
                <button
                  onClick={() => navigate('/', { replace: true })}
                  className="w-full px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors inline-flex items-center justify-center gap-2"
                  data-testid="link-revoked-continue-as"
                >
                  <UserCheck className="w-4 h-4" /> Continue as {accountLabel}
                </button>
                <button
                  onClick={() => navigate('/login?switch=1', { replace: true })}
                  className="w-full px-6 py-2 bg-white/10 text-slate-200 rounded-lg hover:bg-white/20 transition-colors inline-flex items-center justify-center gap-2"
                  data-testid="link-revoked-sign-in-different"
                >
                  <LogIn className="w-4 h-4" /> Sign in as a different user
                </button>
              </div>
            </>
          ) : (
            <>
              <p className="text-slate-400 text-sm mb-6">
                If you still need access, ask your administrator for a new link — or sign in with your username and password.
              </p>
              <button
                onClick={() => navigate('/login', { replace: true })}
                className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                data-testid="link-revoked-go-to-login"
              >
                Go to sign in
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LinkRevoked;
